const i18nConfig = {
	locales: ["ar", "de", "en", "es", "fa", "fj", "fr", "ms", "zh", "ta"],
	defaultLocale: 'en',
	prefixDefault: false
}

module.exports = i18nConfig;